import { render, staticRenderFns } from "./weeklyInfoCollect.vue?vue&type=template&id=6b783285&scoped=true&"
import script from "./weeklyInfoCollect.vue?vue&type=script&lang=js&"
export * from "./weeklyInfoCollect.vue?vue&type=script&lang=js&"
import style0 from "./weeklyInfoCollect.vue?vue&type=style&index=0&id=6b783285&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b783285",
  null
  
)

export default component.exports